"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTimeValidation = useTimeValidation;
exports.useDateValidation = useDateValidation;
exports.useDateTimeValidation = useDateTimeValidation;
exports.useDateRangeValidation = useDateRangeValidation;

var React = _interopRequireWildcard(require("react"));

var _useUtils = require("./useUtils");

var _dateUtils = require("../date-utils");

var _dateTimeUtils = require("../date-time-utils");

var _timeUtils = require("../time-utils");

function isSameDateOrTimeError(a, b) {
  return a === b;
}

function isSameDateRangeError(a, b) {
  return b !== null && a[1] === b[1] && a[0] === b[0];
}

function useValidation(props, validate, isSameError = isSameDateOrTimeError) {
  const {
    value,
    onError
  } = props;
  const utils = (0, _useUtils.useUtils)();
  const previousValidationErrorRef = React.useRef(null);
  const validationError = validate(utils, value, props);
  React.useEffect(() => {
    if (onError && !isSameError(validationError, previousValidationErrorRef.current)) {
      onError(validationError, value);
    }

    previousValidationErrorRef.current = validationError;
  }, [isSameError, onError, previousValidationErrorRef, validationError, value]);
  return validationError;
}

function useTimeValidation(props) {
  return useValidation(props, _timeUtils.validateTime, isSameDateOrTimeError);
}

function useDateValidation(props) {
  return useValidation(props, _dateUtils.validateDate, isSameDateOrTimeError);
}

function useDateTimeValidation(props) {
  return useValidation(props, _dateTimeUtils.validateDateTime, isSameDateOrTimeError);
}

function useDateRangeValidation(props) {
  return useValidation(props, _dateUtils.validateDateRange, isSameDateRangeError);
}